import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TaskService } from '../../services/task.service';
import { CondominiumService } from '../../services/condominium.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-task-create',
    templateUrl: './task-create.component.html',
    styleUrls: ['./task-create.component.sass'],
    standalone: false
})
export class TaskCreateComponent implements OnInit {
  taskForm: UntypedFormGroup;
  minDate = new Date();
  priorities = [
    { value: 'HIGH', label: 'Alta' },
    { value: 'NORMAL', label: 'Normal' },
    { value: 'LOW', label: 'Baixa' }
  ];
  recurrentOptions = [
    { value: 'NONE', label: 'Não' },
    { value: 'WEEKLY', label: 'Semanal' },
    { value: 'MONTHLY', label: 'Mensal' },
    { value: 'YEARLY', label: 'Anual' }
  ];
  condominiumId: number | null = null;
  isLoading = false;

  constructor(
    private taskService: TaskService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.taskForm = this.fb.group({
      targetDate: ['', Validators.required],
      priority: ['NORMAL', Validators.required],
      recurrentType: ['NONE', Validators.required],
      title: ['', [Validators.required, Validators.minLength(3)]],
      body: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit(): void {
    let routeIdParam = this.route.parent?.snapshot.paramMap.get('id');
    if (routeIdParam) {
      this.condominiumId = Number.parseInt(routeIdParam);
    } else {
      this.router.navigate(['/condominiums']);
    }
  }

  onSubmit(): void {
    if (this.taskForm.valid && this.condominiumId) {
      this.isLoading = true;
      const taskData = {
        ...this.taskForm.value,
        condominiumId: this.condominiumId
      };

      if (taskData.recurrentType === 'NONE') {
        taskData.recurrentType = null;
      }
      
      this.taskService.createTask(taskData).subscribe({
        next: () => {
          this.snackBar.open('Task created successfully!', 'Close', { duration: 3000 });
          this.router.navigate([`/condominium/${this.condominiumId}/tasks`]);
        },
        error: (error) => {
          console.error('Error creating task:', error);
          this.snackBar.open('Error creating task', 'Close', { duration: 3000 });
          this.isLoading = false;
        }
      });
    }
  }

  onCancel(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/dashboard`]);
    } else {
      this.router.navigate(['/condominiums']);
    }
  }

  get isRecurrent(): boolean {
    return this.taskForm.get('recurrentType')?.value !== 'NONE';
  }
}
